'use strict';
angular.module('resWechatRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.classifiedresource.wechat.resource', {
                url: '/resource?acode&media_id&fcode&hybase_id&param_data&medianame',
                views: {
                    'networksource@front.networksource.classifiedresource.wechat': {
                        templateUrl: './networkResource/classifiedResource/wechat/main_tpl.html',
                        controller: 'resCenWechatMainCtrl',
                    },
                },
            })
            .state('front.networksource.classifiedresource.wechat.quickpreview', {
                url: '/quickpreview?acode&media_id&fcode&hybase_id&param_data&guid',
                views: {
                    'networksource@front.networksource.classifiedresource.wechat': {
                        templateUrl: './networkResource/classifiedResource/wechat/quickPreview/main_tpl.html',
                        controller: 'wechatQuickPreviewCtrl',
                    },
                },
            });
    },
]);
